import React, { useId } from 'react';
import { SERIF } from '../theme';

// Illustrated pet face avatar — used in cards, pins, profile
// Falls back to image if `src` provided (real pet photo)
export default function PetAvatar({
  size = 56,
  species = 'dog',
  name = 'มะลิ',
  halo = false,
  theme,
  src,
  testId,
}) {
  const uid = useId().replace(/:/g, '');
  const safeName = String(name || 'pet').toLowerCase().replace(/[^a-z0-9ก-๙]+/gi, '-').replace(/^-|-$/g, '') || 'pet';
  const resolvedTestId = testId || `pet-avatar-${safeName}-${uid}`;
  const colors = species === 'cat'
    ? { fur: '#E8B07A', ear: '#C68A55', nose: '#3B2413' }
    : { fur: '#D4A574', ear: '#B8895A', nose: '#3B2413' };

  const haloShadow = theme && halo
    ? `0 0 0 3px ${theme.surface}, 0 0 0 5px ${theme.primary}`
    : `0 2px 6px rgba(0,0,0,0.12)`;

  if (src) {
    return (
      <div data-testid={resolvedTestId} style={{
        width: size, height: size, borderRadius: '50%',
        overflow: 'hidden', flexShrink: 0,
        boxShadow: haloShadow,
      }}>
        <img src={src} alt={name} style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
      </div>
    );
  }

  return (
    <div
      data-testid={resolvedTestId}
      style={{
        width: size, height: size, borderRadius: '50%',
        background: `linear-gradient(135deg, ${colors.fur}, ${colors.ear})`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: '#fff', fontFamily: SERIF, fontSize: size * 0.45, fontWeight: 600,
        boxShadow: haloShadow,
        flexShrink: 0, position: 'relative', overflow: 'hidden',
      }}
    >
      {/* ears */}
      <div style={{ position:'absolute', top: -size*0.05, left: size*0.1, width: size*0.3, height: size*0.3, background: colors.ear, borderRadius: '50% 50% 50% 50% / 70% 70% 30% 30%', transform: 'rotate(-25deg)' }}/>
      <div style={{ position:'absolute', top: -size*0.05, right: size*0.1, width: size*0.3, height: size*0.3, background: colors.ear, borderRadius: '50% 50% 50% 50% / 70% 70% 30% 30%', transform: 'rotate(25deg)' }}/>
      {/* eyes */}
      <div style={{ position:'absolute', top: size*0.4, left: size*0.28, width: size*0.1, height: size*0.12, background: colors.nose, borderRadius:'50%' }}/>
      <div style={{ position:'absolute', top: size*0.4, right: size*0.28, width: size*0.1, height: size*0.12, background: colors.nose, borderRadius:'50%' }}/>
      {/* nose */}
      <div style={{ position:'absolute', top: size*0.55, left: '50%', transform:'translateX(-50%)', width: size*0.14, height: size*0.1, background: colors.nose, borderRadius:'50% 50% 60% 60%' }}/>
      {/* mouth */}
      <div style={{ position:'absolute', top: size*0.65, left: '50%', transform:'translateX(-50%)', width: size*0.18, height: size*0.08, borderBottom: `2px solid ${colors.nose}`, borderLeft:`2px solid ${colors.nose}`, borderRight:`2px solid ${colors.nose}`, borderRadius:'0 0 50% 50%' }}/>
    </div>
  );
}
